// SAMPLE DATA
const SampleData = {
    users: {
        1: {
            id: 1,
            firstName: 'First',
            lastName: 'User',
            avatar: 'avatar-2.jpg'
        },
        2: {
            id: 2,
            firstName: 'Second',
            lastName: 'User',
            avatar: 'avatar-2.jpg'
        }
    },
    defaultProject: function() {
        return {
            title: '',
            lastChangedDate: new Date(),
            lastChangedBy: '',
            version: '',
            mutations: [],
            pages: [],
            collaborators: [],
            layers: [],
            activeVersion: '',
            showVersion: '',
            versions: []
        };
    },
    projects: [
        {
            id: 1,
            title: 'Most Recent Project',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob',
            version: 'V1.2',
            mutations: [],
            activeVersion: 'V1.2',
            showVersion: 'V1.2',
            documentUrl: './static/pdfs/legend.pdf',
            versions: [
                {
                    title: 'Most Recent Project',
                    version: 'V1.2',
                    lastChangedBy: 'Bob',
                    mutations: [
                        {
                            date: new Date(),
                            user: 'Bob'
                        },
                        {
                            date: new Date(),
                            user: 'Jane'
                        }
                    ]
                },
                {
                    title: 'Most Recent Project v1.1',
                    version: 'V1.1',
                    lastChangedBy: 'Charlie',
                    mutations: [
                        {
                            date: new Date(),
                            user: 'Billy Jean'
                        }
                    ]
                }
            ],
            pages: [
                {
                    pageNumber: 1,
                    cues: [
                        {
                            id: 1,
                            title: 'My First Cue',
                            description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                            layer: 1,
                            x: 175,
                            y: 290,
                            scalarX: 850,
                            scalarY: 1100
                        },
                        {
                            id: 2,
                            title: 'My Second Cue',
                            description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                            layer: 2,
                            x: 186,
                            y: 153,
                            scalarX: 850,
                            scalarY: 1100
                        }
                    ]
                },
                {
                    pageNumber: 2,
                    cues: []
                }
            ],
            collaborators: [
                {
                    id: 1,
                    title: 'Grand Vizier',
                    layerPerms: [
                        {
                            id: 1,
                            edit: true,
                            view: true
                        }
                    ]
                },
                {
                    id: 2,
                    title: 'Sub Person',
                    layerPerms: [
                        {
                            id: 1,
                            edit: true,
                            view: true
                        },
                        {
                            id: 2,
                            edit: false,
                            view: true
                        }
                    ]
                }
            ],
            layers: [
                {
                    id: 1,
                    title: 'Layer 1',
                    color: 'yellow'
                },
                {
                    id: 2,
                    title: 'Layer 2',
                    color: 'pink'
                }
            ]
        },
        {
            id: 2,
            title: 'Project 2',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob',
            version: 'V1.2',
            pages: [
                {
                    pageNumber: 1,
                    cues: [
                        {
                            id: 1,
                            title: 'My First Cue',
                            description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                            layer: 1
                        },
                        {
                            id: 2,
                            title: 'My Second Cue',
                            description: 'This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.This is a description. It is longer than the title. a lot longer. very much longer.',
                            layer: 2
                        }
                    ]
                },
                {
                    pageNumber: 2
                }
            ]
        },
        {
            id: 3,
            title: 'Project 3',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 4,
            title: 'Project 4',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 5,
            title: 'Project 5',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 6,
            title: 'Project 6',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 7,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 8,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 9,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 10,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 11,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 12,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 13,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        },
        {
            id: 14,
            title: 'Project 7',
            lastChangedDate: new Date(),
            lastChangedBy: 'Bob'
        }
    ]
};

export default SampleData;


// WEBPACK FOOTER //
// ./sample/sampleData.js